import React, { useState } from "react";
import { Container, Row, Col, Card, CardBody, Button, CardFooter } from "reactstrap";
import Header from "../../components/Header";
import { FormattedMessage, useIntl } from "react-intl";
import { useService } from "../../context/ServiceContext";
import { fireAlert } from "../../utils/alerts";

function AdminActions({ history }) {
  const { crmBulkProcessor, seriesExpressProcessor, pdfBulkProcessor } = useService();
  const [crmProcessing, setCrmProcessing] = useState(false);
  const [pdfImporting, setPdfImporting] = useState(false);
  const [seriesProcessing, setSeriesProcessing] = useState(false);
  const intl = useIntl();

  async function handleCRMBulkProcess() {
    try {
      setCrmProcessing(true);
      await crmBulkProcessor.find();
      showAlert();
    } catch (e) {
      showErrorAlert();
    }
    setCrmProcessing(false);
  }

  async function handlePDFBulkProcess() {
    try {
      setPdfImporting(true);
      await pdfBulkProcessor.find();
      showAlert();
    } catch (e) {
      showErrorAlert();
    }
    setPdfImporting(false);
  }

  async function handleSeriesExpressProcess() {
    try {
      setSeriesProcessing(true);
      await seriesExpressProcessor.find();
      showAlert();
    } catch (e) {
      showErrorAlert();
    }
    setSeriesProcessing(false);
  }

  function showAlert() {
    fireAlert(
      intl.formatMessage({ id: "manage_loadings.successfully_set_request", defaultMessage: "Successfully set request" }),
      intl.formatMessage({ id: "app.success", defaultMessage: "Success" }),
      "success",
    ).then(() => {});
  }

  function showErrorAlert() {
    fireAlert(
      intl.formatMessage({ id: "manage_loadings.unsuccessful_set_request", defaultMessage: "A problem occurred sending the request" }),
      intl.formatMessage({ id: "app.error", defaultMessage: "Error" }),
      "error",
    ).then(() => {});
  }

  return (
    <>
      <Header>
        <h1>
          <FormattedMessage id="admin_actions.title" defaultMessage="Admin Actions" />
        </h1>
      </Header>
      <Container fluid>
        <Row>
          <Col md={6}>
            <Card>
              <CardBody>
                <Row>
                  <Col>
                    <h3 className="card-title">
                      <FormattedMessage id="admin_actions.crm_import.title" defaultMessage="Bulk CRM Import" />
                    </h3>
                    <p className="card-text">
                      <FormattedMessage id="admin_actions.crm_import.description" defaultMessage="Click the button below if you wish to start the CRM bulk product import." />
                    </p>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <Button disabled={crmProcessing} onClick={handleCRMBulkProcess} color="primary">
                  {crmProcessing ? <FormattedMessage id="app.processing" defaultMessage="Processing" /> : <FormattedMessage id="app.proceed" defaultMessage="Proceed" />}
                </Button>
              </CardFooter>
            </Card>
          </Col>
          <Col md={6}>
            <Card>
              <CardBody>
                <Row>
                  <Col>
                    <h3 className="card-title">
                      <FormattedMessage id="admin_actions.series_procedure.title" defaultMessage="Series express" />
                    </h3>
                    <p className="card-text">
                      <FormattedMessage
                        id="admin_actions.series_procedure.description"
                        defaultMessage="Click the button below if you wish to execute the series express procedure."
                      />
                    </p>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <Button disabled={seriesProcessing} onClick={handleSeriesExpressProcess} color="primary">
                  {seriesProcessing ? <FormattedMessage id="app.processing" defaultMessage="Processing" /> : <FormattedMessage id="app.proceed" defaultMessage="Proceed" />}
                </Button>
              </CardFooter>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Card>
              <CardBody>
                <Row>
                  <Col>
                    <h3 className="card-title">
                      <FormattedMessage id="admin_actions.pdf_upload.title" defaultMessage="PDF Import" />
                    </h3>
                    <p className="card-text">
                      <FormattedMessage id="admin_actions.pdf_upload.description" defaultMessage="Click the button below if you wish to start the PDF bulk pdf import." />
                    </p>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <Button disabled={pdfImporting} onClick={handlePDFBulkProcess} color="primary">
                  {pdfImporting ? <FormattedMessage id="app.processing" defaultMessage="Processing" /> : <FormattedMessage id="app.proceed" defaultMessage="Proceed" />}
                </Button>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default AdminActions;
